import React, { Component } from 'react';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import Loadable from 'react-loadable';
import { withRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { func, object, string } from 'prop-types';

import { storePreviousLocation } from '@coconut/services/redux/location';
import {
  setConnected,
  setDisconnected,
} from '@coconut/services/redux/internet';
import { getToken } from '@coconut/services/redux/auth';
import { appLaunch } from '@coconut/services/redux/app';
import { fetchSiteInfo } from '@coconut/services/redux/siteInfo';
import { goToLandingPage } from '@coconut/services/redux/navigation';

import { LOGIN } from '@coconut/constants/landingRoutes';
import ApplicationContext from '@coconut/components/ApplicationContext';
/**
 * Code splitting import starts here.
 *
 * @see
 *  - https://github.com/webpack/webpack/issues/4861
 *  - https://medium.com/faceyspacey/how-to-use-webpacks-new-magic-comment-feature-with-react-universal-component-ssr-a38fd3e296a
 *  - https://medium.com/@addyosmani/a-tinder-progressive-web-app-performance-case-study-78919d98ece0
 *  - https://medium.com/@adamrackis/vendor-and-code-splitting-in-webpack-2-6376358f1923
 *  - https://medium.com/@giang.nguyen.dev/hot-loader-with-react-loadable-c8f70c8ce1a6
 */
const LoadableHome = Loadable({
  loader: () => import(/* webpackChunkName: "home" */ './scenes/Home'),
  loading() {
    return <div />;
  },
});

const LoadableChat = Loadable({
  loader: () => import(/* webpackChunkName: "chat" */ './scenes/Chat'),
  loading() {
    return <div />;
  },
});

const LoadableUploadImage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "uploadImage" */ './scenes/UploadImage'),
  loading() {
    return <div />;
  },
});

const LoadableTutor = Loadable({
  loader: () =>
    import(/* webpackChunkName: "tutorHome" */ './scenes/TutorHome'),
  loading() {
    return <div />;
  },
});

const mapStateToProps = (state) => ({
  token: getToken(state),
});

class App extends Component {
  static propTypes = {
    appLaunch: func.isRequired,
    fetchSiteInfo: func.isRequired,
    goToLandingPage: func.isRequired,
    history: object.isRequired,
    location: object.isRequired,
    setConnected: func.isRequired,
    setDisconnected: func.isRequired,
    storePreviousLocation: func.isRequired,
    token: string,
  };

  static defaultProps = {
    token: '',
  };

  state = {
    hasError: false,
    error: '',
  };

  componentDidMount() {
    const { appLaunch, token, goToLandingPage, fetchSiteInfo } = this.props;

    if (!token) {
      goToLandingPage(LOGIN);

      return;
    }
    // Calling backend appLaunch
    appLaunch(this.context.lang);
    fetchSiteInfo();

    window.addEventListener('online', this.updateInternetStatus);
    window.addEventListener('offline', this.updateInternetStatus);
  }

  componentWillReceiveProps(nextProps) {
    const { location } = nextProps;

    if (location !== this.props.location) {
      this.props.storePreviousLocation(this.props.location);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.updateInternetStatus);
    window.removeEventListener('offline', this.updateInternetStatus);
  }

  updateInternetStatus = () => {
    const isOnline = navigator.onLine;
    const { setConnected, setDisconnected } = this.props;

    if (isOnline) {
      setConnected();

      return;
    }
    setDisconnected();
  };

  render() {
    const { hasError, error } = this.state;
    const { history } = this.props;

    if (hasError) {
      return (
        <div>
          {/* @todo renders error boundary component */}
          Runtime rendering error {error}
        </div>
      );
    }

    return (
      <div key={Math.random()}>
        {/* Fix hot module reload problem with react-loadable */}
        <ApplicationContext.Provider value={{ history }}>
          <Switch>
            {/* Home route */}
            <Route
              exact
              path="/:tab(active|completed)?"
              component={LoadableHome}
            />

            {/* Chatroom */}
            <Route
              exact
              path="/chat/:QID" // should it be chat?
              component={LoadableChat}
            />

            {/* UploadImage */}
            <Route exact path="/upload/Image" component={LoadableUploadImage} />

            {/* Tutor, until student mockup ready */}
            <Route exact path="/tutor" component={LoadableTutor} />
          </Switch>
        </ApplicationContext.Provider>
      </div>
    );
  }
}

App.contextTypes = {
  lang: string.isRequired,
};

export default compose(
  withRouter,
  translate(),
  connect(mapStateToProps, {
    appLaunch,
    storePreviousLocation,
    setConnected,
    fetchSiteInfo,
    setDisconnected,
    goToLandingPage,
  })
)(App);



// WEBPACK FOOTER //
// ./src/App.jsx